module.exports = {
      id: "biggan-chinta-usage",
      viewBox: "0 0 156 40",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#biggan-chinta",
      toString: function () {
        return this.url;
      }
    }